export default __webpack_public_path__ + "static/media/earphonesIllustrator.021a47dd.svg";